import {createContext} from 'react';

const cookiesContext = createContext();

export default cookiesContext;